import { BrowserRouter, Route, Routes } from "react-router-dom";
// import { HashRouter, Route, Routes } from "react-router-dom";

import ScrollToTop from "./Elements/ScrollToTop/scroll_top";

// import logo from './logo.svg';
import "./App.css";
import Products from "./Pages/products";
import ProductDetails from "./Pages/productsDetails";

function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Products />} />
          <Route path="/product/:id" element={<ProductDetails />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
